'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isFriday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isFriday.js
// module id = 542
// module chunks = 0